//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum CatiExportCompilationType {
	Cati = 0,
	Cawi = 1,
	All = 2
}
